import i18n from '@app/localization/i18n';

export const PINNED_ID = -1001;
export const PROMOTIONS_ID = -1002;
export const PROMOTIONS_TITLE = i18n.t('super offer').toString();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/sportOffer/constants.ts